import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button } from "antd";
import {
  DownloadOutlined,
  FileTextOutlined,
  GlobalOutlined,
  FileImageOutlined,
} from "@ant-design/icons";
import { multiImageZip } from "../../../../core/utils/dataloading/multiImageZip";
import { CSVLink } from "react-csv";
import { flatten, isEmpty, capitalize } from "lodash";
import LauncherMapSimple from "../../../shared/maps/LauncherMapSimple";
import { GeoTargetsTable } from "../../Campaigns/geotargetmanager/geoTargetManagementComponents/GeoTargetsTable";
import {
  ReviewBasics,
  ReviewCreatives,
} from "../../CampaignLauncher/components";

import { kmToFt } from "../../../../core/utils/campaigns";
import { stateList } from "../../../../core/utils/constants/stateList";
import { withApollo } from "react-apollo";
import CampaignTrackings from "./CampaignTrackings";
import GeotargetStates from "./GeotargetStates";

const styles = {
  cardBody: {
    padding: 0,
  },
  cardRow: {
    padding: "15px",
    borderBottom: "1px solid #e8e8e8",
  },
  secondaryRow: {
    padding: "15px 15px 15px 0",
  },
  textRow: {
    marginBottom: "10px",
  },
  title: {
    color: "#636363",
    margin: 0,
    fontWeight: "normal",
  },
  bannerNameText: {
    maxWidth: "90%",
  },
  bannerCard: {
    height: "150px",
    width: "150px",
  },
  banner: {
    height: "75px",
    width: "75px",
  },
  map: {
    position: "relative",
    height: "300px",
    width: "100%",
  },
  card: {
    marginBottom: "20px",
  },
  titleStyles: {
    iconStyle: {
      color: "#000000", //Previous Color for Reference: #9b9b9b
      fontSize: "22px",
    },
    textStyle: {
      color: "#000000",
    },
  },
};

const CampaignOrderDetails = ({
  client,
  selectedCampaignOrder,
  selectedCampaignOrder: {
    brands,
    name: campaignName,
    category,
    tags,
    startDate,
    endDate,
    budget,
    adUnits,
    isRegulated,
    geoTargets,
    attributionTargets,
    cpm,
    targetingCriteria,
    awarenessCampaign,
    transactionsConfig,
    description,
    type,
    advertiser,
  },
}) => {
  const getGeotargetsLength = geoTargets && geoTargets.length;
  const [formattedTargets, setFormattedTargets] = useState([]);

  const { card, cardBody } = styles;
  const [campaignType, setCampaignType] = useState(null);

  useEffect(() => {
    if (geoTargets) {
      setFormattedTargets(
        geoTargets.map(result => {
          const circle = result.circles[0];
          const redotarget = isEmpty(circle) ? result : circle.location;
          const getRadius = isEmpty(circle) ? "-" : result.circles[0].radius;

          const name =
            circle && circle.location ? circle.location.name : result.name;

          return {
            ...redotarget,
            key: result.id,
            name,
            radius: getRadius,
            status: result.status,
          };
        })
      );
    }
  }, [geoTargets]);

  useEffect(() => {
    switch (type) {
      case "DISPLAY":
        setCampaignType(1);
        break;

      default:
        break;
    }
  }, [type]);

  return (
    <Row type="flex" gutter={12}>
      <Col span={24}>
        <Card
          style={card}
          title={
            <Col>
              <span>
                <FileTextOutlined /> Basics
              </span>
            </Col>
          }
        >
          <ReviewBasics
            brands={brands}
            campaignName={campaignName}
            startDate={startDate}
            endDate={endDate}
            category={category}
            tags={tags}
            isRegulated={isRegulated}
            budget={budget}
            cpm={cpm}
            targetingCriteria={targetingCriteria}
            awarenessCampaign={awarenessCampaign}
            cart={transactionsConfig && transactionsConfig.cart}
            transactionTarget={transactionsConfig && transactionsConfig.appId}
            traffId={transactionsConfig && transactionsConfig.traffId}
            gtmAccess={transactionsConfig && transactionsConfig.gtmAccess}
            gtmStatus={transactionsConfig && transactionsConfig.gtmStatus}
            description={description}
            type={campaignType}
            name={advertiser ? advertiser.name : ""}
          />
        </Card>

        <Card span={24} style={{ marginBottom: "20px" }}>
          <Col>
            <GeotargetStates
              geoTargets={geoTargets}
              attributionTargets={attributionTargets}
            />
          </Col>
        </Card>
        {/* <Card
          style={card}
          title={
            <Col>
              <span>
                <GlobalOutlined /> Demographics
              </span>
            </Col>
          }
        >
          <Row style={cardRow}>
            <Col xs={24}>
              <ReviewDemographics
                age={age}
                language={language}
                income={income}
                segments={segments}
                devices={devices}
              />
            </Col>
          </Row>
        </Card> */}
        <Card
          style={card}
          title={
            <div style={{ position: "relative" }}>
              <Col>
                <span>
                  <GlobalOutlined /> Geo Targets
                </span>
              </Col>
              <Button
                style={{ position: "absolute", right: 0, top: -4 }}
                disabled={!geoTargets || geoTargets.length === 0}
              >
                <CSVLink
                  filename={`${campaignName}-Geo.csv`}
                  style={{ textDecoration: "none" }}
                  data={flatten(
                    geoTargets.map((geoTarget, i) => {
                      const output = [];
                      geoTarget.circles.forEach(circle => {
                        let state = "";
                        let getCode = "";
                        if (circle.location && circle.location.state) {
                          state = capitalize(circle.location.state);

                          const getState = stateList.filter(val => {
                            return state === val.State && val.Code;
                          });

                          getCode =
                            getState && getState.length && getState[0].Code;
                        }

                        output.push({
                          Name: circle.location && circle.location.name,
                          Type: "CIRCLE",
                          Address:
                            circle.location && circle.location.formattedAddress,
                          Street: circle.location && circle.location.street,
                          City: circle.location && circle.location.city,
                          County: circle.location && circle.location.county,
                          State: circle.location && getCode,
                          Country: circle.location && circle.location.country,
                          Zip: circle.location && circle.location.zip,
                          Latitude: circle.coordinate.lat,
                          Longitude: circle.coordinate.lng,
                          Radius: Math.round(kmToFt(circle.radius)),
                        });
                      });

                      geoTarget.polygons.forEach(polygon => {
                        if (!isEmpty(polygon.coordinates)) {
                          output.push({
                            GeoTarget: i,
                            Type: "POLYGON",
                            Latitude: polygon.coordinates[0].lat,
                            Longitude: polygon.coordinates[0].lng,
                          });
                          polygon.coordinates.forEach((coordinate, i) => {
                            if (i > 0)
                              output.push({
                                Latitude: polygon.coordinates[i].lat,
                                Longitude: polygon.coordinates[i].lng,
                              });
                          });
                        }
                      });
                      return output;
                    })
                  )}
                >
                  <DownloadOutlined /> Download CSV
                </CSVLink>
              </Button>
            </div>
          }
          bodyStyle={cardBody}
        >
          {getGeotargetsLength !== 0 && (
            <React.Fragment>
              <LauncherMapSimple
                geoTargets={geoTargets && [geoTargets[0]]}
                zoom={5}
                styles={styles}
              />
              <GeoTargetsTable
                geoTargets={formattedTargets}
                type={"Geo"}
                showRowStatus={true}
              />
            </React.Fragment>
          )}
        </Card>
        <Card
          style={card}
          title={
            <div style={{ position: "relative" }}>
              <Col>
                <span>
                  <FileImageOutlined /> Creatives
                </span>
              </Col>
              <Button
                style={{ position: "absolute", right: 0, top: -4 }}
                onClick={() => multiImageZip(campaignName, adUnits)}
                disabled={!adUnits.some(item => item.banners.length > 0)}
              >
                <DownloadOutlined /> Download Creatives
              </Button>
            </div>
          }
        >
          <ReviewCreatives adUnits={adUnits} />
        </Card>
        <Card
          style={card}
          title={
            <div style={{ position: "relative" }}>
              <Col>
                <span>
                  <FileImageOutlined /> Tracking
                </span>
              </Col>
            </div>
          }
        >
          <CampaignTrackings selectedCampaignOrder={selectedCampaignOrder} />
        </Card>
      </Col>
    </Row>
  );
};

export default withApollo(CampaignOrderDetails);
